import { hasNonDigitCharacters } from '../helpers/index.js';

var INVALID_CHARACTERS_ERROR_MESSAGE = 'БИК может состоять только из цифр';
var INVALID_LENGTH_MESSAGE = 'БИК должен состоять из 9 цифр';
var validBik = function (message) {
  if (message === void 0) {
    message = 'Введите корректный БИК';
  }

  return function (value) {
    if (!value) {
      return message;
    }

    if (hasNonDigitCharacters(value)) {
      return INVALID_CHARACTERS_ERROR_MESSAGE;
    }

    if (value.length !== 9) {
      return INVALID_LENGTH_MESSAGE;
    }

    var bank = value.substr(6);
    var numberBank = Number.parseInt(bank, 10);

    if (numberBank >= 50 && numberBank <= 999) {
      return;
    }

    return message;
  };
};

export default validBik;
export { INVALID_CHARACTERS_ERROR_MESSAGE, INVALID_LENGTH_MESSAGE, validBik };
